import { Row, RenderConfig, TextInput, Column, EMPTY_ARRAY } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	ZUPEE_USER_ID: 'ZupeeUserId'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: 'ZupeeUserId'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ZUPEE_USER_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ZUPEE_USER_ID])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ZUPEE_USER_ID)])])];
